export default class BlockSliderTab {
	static init() {

		let blocks = document.querySelectorAll('.block-slider-tab');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper-text');
			const swiperImage = block.querySelector('.swiper-images');
			const swiperTab = block.querySelector('.swiper-tabulation');
			const prev = block.querySelector(".swiper-custom-button-prev");
			const next = block.querySelector(".swiper-custom-button-next");

			let swiperTabulation = new Swiper(swiperTab, {
				slidesPerView: "auto",
				spaceBetween: 40,
				loop: false,
				speed: 600,
				clickable: true
			});

			let swiperImages = new Swiper(swiperImage, {
				slidesPerView: 1,
				speed: 600,
				allowTouchMove: false,
				effect: "creative",
				creativeEffect: {
					prev: {
						translate: [0, 0, -100],
						opacity: 0
					},
					next: {
						translate: [0, 0, -100],
						opacity: 0
					}
				},
			});

			let swiperText = new Swiper(swiper, {
				slidesPerView: 1,
				allowTouchMove: false,
				speed: 600,
				effect: "creative",
				creativeEffect: {
					prev: {
						translate: ["-200%", 0, -400],
						opacity: 0
					},
					next: {
						translate: ['200%', 0, -400],
						opacity: 0
					},
				},
				thumbs: {
					swiper: swiperTabulation
				},
				on: {
					slideChange: function () {
						// Met à jour le thumbsSwiper pour centrer l'élément actif
						swiperTab.swiper.slideTo(this.activeIndex);
					}
				},
			});

			swiperText.controller.control = swiperImages;

		});
	}
}
